import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  loader: true,
  loaderText: null,
  theme: 'default',
  legal: {},
  errorPage: {
    notFound: '',
    api: ''
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
